import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";

export const CTASection = () => (
  <section data-testid="cta-section" className="bg-blueprint relative overflow-hidden">
    <div className="absolute inset-0 blueprint-grid opacity-30" style={{ ["--grid-line" as string]: "rgba(255,255,255,0.12)" }} />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-20 md:py-28 flex flex-col md:flex-row md:items-center md:justify-between gap-10">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <p className="font-mono-tech text-[11px] tracking-[0.25em] uppercase text-[#FFD60A] mb-4">Ready to build?</p>
        <h2 className="font-heading font-medium text-3xl md:text-4xl tracking-tight text-white max-w-2xl">
          Tell us about your project. We'll bring the plan, the crew, and the discipline.
        </h2>
      </motion.div>
      <div className="flex flex-wrap gap-4 shrink-0">
        <Link
          to="/quote"
          data-testid="cta-quote-btn"
          className="group inline-flex items-center gap-3 px-7 py-4 bg-[#FFCC00] text-black text-sm font-semibold tracking-wide transition-all hover:bg-white"
        >
          Request a Quote <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
        </Link>
        <Link
          to="/contact"
          data-testid="cta-contact-btn"
          className="inline-flex items-center px-7 py-4 border border-white/40 text-white text-sm font-medium tracking-wide transition-colors hover:border-white hover:bg-white/10"
        >
          Contact Us
        </Link>
      </div>
    </div>
  </section>
);
